
import { Component, Prop, Vue } from "vue-property-decorator";
import { getColorOptions } from "../service/ColorService";
import { ColorId } from "../model/misc";

@Component
export default class ColorPicker extends Vue {
  @Prop() value!: ColorId;

  private colorOptions = getColorOptions();
}
